import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase.js';
import { ANBAUGEBIETE } from '../data/regionsAndBereiche.js';

// Preloads all notable/GG vineyards, villages, and producers at startup.
// Returns a flat array of { kind, id, name, anbaugebiet, bereich, latitude, longitude }.
// Used for instant zoom-to-coordinate on search result selection before region data loads.
// staticFirst (anonymous visitors): the build-time CDN copy
// (/regions-data/key-items.json) with the RPC as fallback; signed-in
// users always fetch live.

export function useKeyItems(staticFirst = false) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let cancel = false;
    const apply = (data) => {
      if (cancel) return;
      // Build a lookup map by kind+id for O(1) access
      const map = new Map();
      for (const item of data ?? []) {
        map.set(`${item.kind}-${item.id}`, item);
      }
      setItems(map);
    };
    const live = () => supabase.rpc('key_items_all').then(({ data, error }) => {
      if (cancel) return;
      if (error) { console.error('[useKeyItems]', error.message); return; }
      apply(data);
    });
    if (staticFirst) {
      fetch('/regions-data/key-items.json')
        .then(res => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
        .then(data => {
          if (!Array.isArray(data) || data.length === 0) throw new Error('thin static data');
          // atlas guard: foreign-country bake -> fall through to live
          if (!data.every(item => ANBAUGEBIETE.includes(item.anbaugebiet))) throw new Error('foreign atlas static data');
          apply(data);
        })
        .catch(() => live());
    } else {
      live();
    }
    return () => { cancel = true; };
  }, [staticFirst]);

  return items;
}
